import { FC } from 'react'
import { RenderIf } from 'components/RenderIf'
import { useTranslations } from 'featureSliced/shared/hooks/useTranslations'
import { IProduct } from 'featureSliced/shared/store/reducers/CategoriesReducer/types'
import { useOpenProductInfoModal } from '../../useOpenProductInfoModal'

import { InfoCircle } from './styled'

type ProductInfoButtonProps = {
  product: IProduct
}

export const ProductInfoButton: FC<ProductInfoButtonProps> = ({ product }) => {
  const t = useTranslations()
  const openProductInfo = useOpenProductInfoModal()

  return (
    <RenderIf condition={product.hasProductInfo === true}>
      <InfoCircle
        type="button"
        aria-label={t('productInfo.open')}
        data-testid="product_info_button"
        onClick={() => openProductInfo(product)}
      >
        <svg
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2.2"
          strokeLinecap="round"
          aria-hidden="true"
        >
          <path d="M12 11v6" />
          <path d="M12 7.5h.01" />
        </svg>
      </InfoCircle>
    </RenderIf>
  )
}
